import apiClient from './apiClient';

/**
 * Get platform states (public). Returns single document or null.
 */
export const getPlatformStates = async () => {
  try {
    const { data } = await apiClient.get('/api/platform-stats');
    return data;
  } catch (err) {
    if (err.response?.status === 404) return null;
    throw err;
  }
};

/**
 * Create platform states (admin).
 */
export const createPlatformStates = async (payload) => {
  const { data } = await apiClient.post('/api/platform-stats', payload);
  return data;
};

/**
 * Update platform states (admin).
 */
export const updatePlatformStates = async (id, payload) => {
  const { data } = await apiClient.put(`/api/platform-stats/${id}`, payload);
  return data;
};
